<template>
  <app-Users v-if="area == 'users'"></app-Users>
  <app-Licences v-else-if="area == 'licences'"></app-Licences>
  <app-Projects v-else-if="area == 'projects'"></app-Projects>
  <app-Dashboard v-else></app-Dashboard>
</template>

<script>
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import Dashboard from './components/dashboard.vue'
import Users from './components/users.vue'
import Projects from './components/projects.vue'
import Licences from './components/licences.vue'

import {required} from 'vuelidate/lib/validators'
import {todayDate} from '../common'
export default {
  name: 'customer',
  components: {
    appDashboard: Dashboard,
    appUsers: Users,
    appProjects: Projects,
    appLicences: Licences
  },
  data () {
    return {
      'fromCustomers': 1,
      'customerdata': {},
      'area': 'dashboard'
    }
  },

  mounted () {
    if(this.$route.params.area) {
      this.area = this.$route.params.area
    }
    console.log('customer', this.$route.params.customerid, this)
  },

  methods: {

  },

  watch: {
    $route: function() {
      console.log('WATCH', this.$route.params.area)
      this.area = this.$route.params.area
    }
  },

  created () {
    console.log('created')
  }
}
</script>

<style>

.formfont {
  font-size: 0.8rem !important;
}

.sidenav {
  padding-top: 0px !important;
}

.blockgrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 25px;
  grid-row-gap: 25px;
  align-items: center;
  justify-content:center;
}

.blockspace {
  text-align: center;
  padding-top:25px;
  padding-bottom:25px;
  background: #3A3;
  border-radius: 15px;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.blockspace.overuse {
  background-color: #e67474;
}

td.overuse {
  color: #C04E4E;
  font-weight:bold;
}

.minheight100 {
  min-height:100vh;
}

.main-customer {
  padding-top: 120px !important;
  padding-left:1rem !important;
  padding-right: 1rem !important;
  padding-bottom:1rem !important;
}

#sidebar .switch label .lever:before, #sidebar .switch label .lever:after {
  height: 12px;
  width: 12px;
}

.switch label .lever {
  border: 1px solid #adb5bd !important;
  height:18px !important;
}

.switch label .lever:before,
.switch label .lever:after {
  top: 2px !important;
}
.switch label,
.switch label span
{
  margin-top:0 !important;
  margin-bottom:0 !important;
}

/* Table Style */


thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background-color: #f8f8f8;
  font-size:14px;

}

tbody tr:hover {
  background: lightgray !important;
  color: #212529;
  //cursor: pointer;
}

input.custom-control-input:disabled + span {
  background-color: #daedff !important;
}

input.custom-control-input:disabled + span:after {
  background-color: #adb5bd !important;
}

</style>



// WEBPACK FOOTER //
// src/components/customer/index.vue